import React, { useEffect, useCallback, useRef } from 'react';
import { useModal } from 'mui-modal-provider';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client';

import {
  Appointment as AppointmentView,
} from './appointment';
import { useGoBack } from '../../../../hooks/use-go-back';
import { CancelAppointmentModal } from './cancel-appointment-modal';
import { NoActiveAppointmentModal } from './no-active-appointment-modal';
import { isAppointmentContentShow } from '../../../../utils/appointment/is-appoinment-content-show';
import { InternalLinks } from '../../../../constants';
import { GET_IS_USER_LOGGED_IN } from '../../../../graphql/user/queries';
import {
  IConsumerAppointments,
} from '../../../../graphql/appointments/models/get-appointments.models';
import { GET_APPOINTMENTS } from '../../../../graphql/appointments/queries/get-appointments';
import { pushStoreCodeIfEnabled } from '../../../../utils';

export const Appointment = (): JSX.Element => {
  const { data: { user: { isLoggedIn } } } = useQuery(GET_IS_USER_LOGGED_IN);
  const { data, loading, error } = useQuery<IConsumerAppointments>(GET_APPOINTMENTS, { skip: !isLoggedIn, fetchPolicy: 'network-only' });
  const appointments = data?.allAppointmentsByAuthId?.edges || [];
  const { showModal } = useModal();
  const { goBack } = useGoBack();
  const navigate = useNavigate();
  const modalShownRef = useRef(false);

  const onNavigate = useCallback(() => {
    navigate(InternalLinks.home);
  }, [navigate]);

  const handleNavigateToEcp = useCallback(() => {
    navigate(InternalLinks.ecpLocator);
  }, [navigate]);

  const handleNavigateToHome = useCallback(() => {
    navigate(InternalLinks.home);
  }, [navigate]);

  const handleCancelButtonClick = () => {
    const code = appointments[0]?.node?.store?.code;
    if (code) {
      pushStoreCodeIfEnabled(code);
    }

    showModal(CancelAppointmentModal, {
      appointmentId: appointments?.[0]?.node?.id,
      appointmentType: appointments?.[0]?.node?.appointmentType,
      onNavigate,
    });
  };

  const handleAppointmentBack = () => {
    goBack();
  };

  useEffect(() => {
    const isNoAppointments = (!loading || !!error) && (!appointments?.length || !isAppointmentContentShow(
      appointments?.[0]?.node?.date, appointments?.[0]?.node?.status,
    ));
    if (isNoAppointments) {
      modalShownRef.current = true;
      showModal(NoActiveAppointmentModal, {
        onNavigateToEcp: handleNavigateToEcp,
        onNavigateToHome: handleNavigateToHome,
      });
    }
  }, [appointments, showModal, handleNavigateToEcp, handleNavigateToHome, loading]);

  return (
    <AppointmentView
      appointments={appointments || []}
      isLoading={loading}
      isError={!!error}
      onCancelClick={handleCancelButtonClick}
      onAppointmentClose={handleAppointmentBack}
    />
  );
};
